import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SubmitButton from '../pages/AuthPages/SubmitButton';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { auth } from '../firebase';

export default function FormDialog({
  title,
  content,
  onChangeText,
  _id,
  category,
  cardHeader,
  type = 'note',
  description,
  charactersLimit = 260,
  rows = 4,
  verticalId,
}) {
  const [open, setOpen] = React.useState(false);
  const [text, setText] = React.useState(content);
  const actionName = content?.length > 0 ? 'Edit' : 'Add';
  const inputRef = React.useRef(null);

  const handleClickOpen = (event) => {
    event.stopPropagation();
    setText(text || '');
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Set cursor position to end of text when dialog opens
  const handleTextFieldFocus = (event) => {
    // Move cursor to end of text
    const input = event.target;
    const textLength = input.value.length;

    if (open) {
      input.setSelectionRange(textLength, textLength);
    }
  };

  const addHandler = async (event) => {
    const token = await auth.currentUser.getIdToken();
    let urlSuffix = '';
    if (category === 'people') {
      if (cardHeader === 'AUTHOR') {
        urlSuffix = 'author';
      } else if (cardHeader === 'INVENTOR') {
        urlSuffix = 'inventor';
      } else if (
        cardHeader === 'CREATOR' ||
        cardHeader === 'EDITOR' ||
        cardHeader === 'MEMBER'
      ) {
        urlSuffix = 'user_by_id';
      } else {
        urlSuffix = 'person';
      }
    } else {
      urlSuffix = `${category.slice(0, -1)}`;
    }

    const url =
      process.env.REACT_APP_FLASK_WEBSERVER + `edit_${urlSuffix}?id=${_id}&vertical_id=${verticalId}`;

    const res = await fetch(url, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ [type]: text }),
    });
    await res.json();
    onChangeText(text);
    return res.status;
  };

  return (
    <React.Fragment>
      <img
        src={`${process.env.PUBLIC_URL}/pen.svg`}
        alt="edit"
        className="detail-icon clickable"
        style={{ border: 'none' }}
        onClick={handleClickOpen}
      />

      <Dialog
        onClick={(event) => event.stopPropagation()}
        open={open}
        fullWidth={true}
        maxWidth={'md'}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            handleClose();
          },
        }}
      >
        <DialogTitle
          style={{ textAlign: 'left', fontWeight: 700, fontSize: '26px', lineHeight: '33.8px' }}
        >
          {actionName} {title}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={() => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: 'black',
          })}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              fontWeight: 400,
              fontSize: '16px',
              color: '#596274',
            }}
          >
            <DialogContentText>Add what you think is the most important about this {description}</DialogContentText>
            <DialogContentText>
              {text?.length ? text.length : 0} / {charactersLimit}
            </DialogContentText>
          </div>
          <TextField
            inputRef={inputRef}
            autoFocus
            required={actionName === 'Add'}
            margin="dense"
            id={type}
            name={type}
            type="text"
            fullWidth
            variant="outlined"
            multiline
            rows={rows}
            onChange={(e) => setText(e.target.value.substring(0, charactersLimit))}
            value={text}
            onFocus={handleTextFieldFocus}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            sx={{
              textTransform: 'none',
              fontWeight: 700,
              fontSize: '16px',
              borderColor: '#356AC3',
              height: '36px',
            }}
          >
            Cancel
          </Button>
          <SubmitButton
            text={actionName}
            disabled={text?.length === 0 && actionName === 'Add'}
            disabledText={actionName}
            width={'64px'}
            height={'36px'}
            onClick={addHandler}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
